import * as React from 'react';
export const subscriptionSvg = React.forwardRef(function subscriptionSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.45.75a.7.7 0 1 0-1.4 0v.75H4a3 3 0 0 0-3 3v6.25A3.25 3.25 0 0 0 4.25 14a.75.75 0 0 0 0-1.5 1.75 1.75 0 0 1-1.75-1.75V7h11v2.25a2.25 2.25 0 0 1-2.25 2.25H8.705l1.598-1.743a.75.75 0 0 0-1.106-1.014l-2.75 3a.75.75 0 0 0 0 1.014l2.75 3a.75.75 0 0 0 1.106-1.014L8.705 13h2.545A3.75 3.75 0 0 0 15 9.25V4.5a3 3 0 0 0-3-3h-1.05V.75a.7.7 0 1 0-1.4 0v.75h-3.1V.75ZM13.5 5.5v-1A1.5 1.5 0 0 0 12 3h-1.05v.75a.7.7 0 1 1-1.4 0V3h-3.1v.75a.7.7 0 1 1-1.4 0V3H4a1.5 1.5 0 0 0-1.5 1.5v1h11Z',
    }),
  );
});
subscriptionSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var subscription = {
  category: 'icon',
  colorable: true,
  name: 'subscription',
  svg: subscriptionSvg,
};
